import React from 'react';
import PropTypes from 'prop-types';
import { SkeletonItem } from '@paygreen/paygreen-ui';

const SkeletonTextLine = ({
    blockWidth,
    colorWab,
    isLoading,
    blockHeight,
    ...rest
}) => {
    return (
        <SkeletonItem
            skeletonItemType="text"
            blockWidth={blockWidth}
            blockHeight={blockHeight}
            colorWab={colorWab}
            isLoading={isLoading}
            {...rest}
        />
    );
};

SkeletonTextLine.propTypes = {
    blockWidth: PropTypes.string,
    colorWab: PropTypes.string,
    isLoading: PropTypes.bool,
};

SkeletonTextLine.defaultProps = {
    blockWidth: 'auto',
    colorWab: 'grey20',
    isLoading: false,
    blockHeight: 'tiny',
};

export default SkeletonTextLine;
